module.exports = __webpack_public_path__ + "static/img/14000356.ff32654c.png";